import React from "react";
import PageHero from "../components/PageHero";
import TeamSection from "../components/TeamSection";
import CreatorBooking from "../components/CreatorBooking";
import TestimonialsStrip from "../components/TestimonialsStrip";
import SEO from "../components/SEO";

const TeamPage = () => {
  return (
    <>
      <SEO
        title="Team – Kreative Köpfe hinter FREEAYTO"
        description="Lerne das Team kennen: Keanu Irle (Top UGC Creator 2024), Kacper (Video-Spezialist) und Stella (KI-Automation). Strategischer Partner, kein Posting-Service."
        path="/team"
        keywords="FREEAYTO Team, Keanu Irle, UGC Creator Deutschland, Video Produktion, KI Automation Social Media"
      />
      <PageHero
        eyebrow="Team"
        title="Strategischer Partner."
        gradient="Kein Posting-Service."
        subtitle="Hinter FREEAYTO steht Keanu Irle – Top UGC Creator 2024 – und ein Kern-Team aus Video-Spezialisten, Editoren und Strategen. Wir denken nicht in Posts, wir denken in Systemen."
      />
      <TeamSection />
      <TestimonialsStrip max={2} eyebrow="Was Kunden über uns sagen" />
      <CreatorBooking />
    </>
  );
};

export default TeamPage;
